/** Catalogue list after a completed/failed generation notification. */
export const CRM_CATALOGUE_NOTIFICATION_ROUTE = '/crm/products?view=catalogues';

export function isCrmCatalogueNotificationTag(tag: string | null | undefined): boolean {
    const value = (tag ?? '').trim().toLowerCase();
    return (
        value === 'crm_catalogue' ||
        value === 'crm-catalogue' ||
        value === 'catalogue' ||
        value === 'catalogue_generated'
    );
}

export function normalizeCrmCatalogueNotificationTag(tag: string): string | null {
    return isCrmCatalogueNotificationTag(tag) ? 'crm_catalogue' : null;
}

/** First-seen unread rows only — same id on a later socket frame is not a new arrival. */
export function unreadNotificationArrivals<T extends { id: unknown; read?: boolean }>(
    previous: T[],
    next: T[],
): T[] {
    const previousIds = new Set((previous ?? []).map(item => String(item.id)));
    return (next ?? []).filter(
        message => !message.read && !previousIds.has(String(message.id)),
    );
}
